import React from "react"
import PropTypes from "prop-types"
import AsyncSelect from 'react-select/async';

class SelectAsset extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
      account: props.account,
      assets: props.assets,
      default_assets: props.default_assets,
      element_id: props.element_id,
      multiple: props.multiple,
      isLoading: true,
    };
  }

  componentDidMount() {
  }

  renderSelectAsset() {
    let debounceTimer;
    const account = this.state.account;
    const assets = this.state.assets;
    const default_assets = this.state.default_assets;
    const element_id = this.state.element_id;
    const multiple = this.state.multiple;

    const handleInputChange = value => {
    };

    const handleChange = value => {
      this.setState({
        assets: value,
      });
      if (multiple) {
        let result = value.map((tag) => tag.id);
        document.getElementById(element_id).value = JSON.stringify(result);
      } else {
        document.getElementById(element_id).value = value ? value.id : null;
      }
    };

    const loadOptions = (value) => {
      return fetch(`/accounts/${account.id}/assets/select?search=${value}`,
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            "Accept": "application/json"
          }
        }
      )
      .then(response => response.json());
    };

    const promiseOptions = (value) =>
      new Promise((resolve) => {
        clearTimeout(debounceTimer);
        debounceTimer = setTimeout(() => {
          resolve(loadOptions(value));
        }, 1000);
      });

    const handleFocus = () => {
      if (!assets && (!default_assets || default_assets.length === 0)) {
        loadOptions("").then((options) => {
          this.setState({ default_assets: options });
        });
      }
    };

    const customOption = (asset) => {
      return (
        <div>
          <div className="d-flex align-items-center">
            <div className="mr-1">
              {asset["title"]}
            </div>
            {asset["badge"] && <div className="ml-auto small">
              {asset["badge"]}
            </div>}
          </div>
          {asset["description"] && <div className="small select-description">
            {asset["description"]}
          </div>}
        </div>
      );
    }

    return (
      <AsyncSelect
        cacheOptions
        defaultOptions={default_assets}
        isMulti={multiple}
        placeholder={this.props.placeholder || "Select an asset..."}
        value={assets}
        getOptionLabel={c => customOption(c)}
        getOptionValue={c => c.id}
        loadOptions={promiseOptions}
        onInputChange={handleInputChange}
        onChange={handleChange}
        onFocus={handleFocus}
        isClearable
        styles={{
          singleValue: (base) => ({ ...base, width: '96%' }),
          valueContainer: (base) => ({ ...base, minHeight: '44px'}),
        }}
      />
    );
  }

  render () {
    return (
      <div>
        {this.renderSelectAsset()}
      </div>
    );
  }
}

SelectAsset.propTypes = {
  account: PropTypes.object,
  assets: PropTypes.object,
  default_assets: PropTypes.array,
  element_id: PropTypes.string,
  multiple: PropTypes.bool,
  placeholder: PropTypes.string,
};

export default SelectAsset;
